import React from 'react';
import './index.css';
import clsx from 'classnames';
import TweenOne from 'rc-tween-one';
import 'rc-banner-anim/assets/index.css';

const Banner = () => {
  const onContact = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  };

  return (
    <div className={clsx('banner')}>
      <div className={clsx('banner-mask')} />
      <div className={clsx('banner-content')}>
        <TweenOne
          className={clsx('banner-title')}
          animation={{ y: 30, opacity: 0, type: 'from' }}
        >
          精准检测，质量交付
        </TweenOne>
        <TweenOne
          className={clsx('banner-text')}
          animation={{ y: 40, opacity: 0, type: 'from', delay: 100 }}
        >
          Precise detection, quality delivery
        </TweenOne>
        <TweenOne
          className={clsx('banner-button')}
          onClick={onContact}
          animation={{ y: 50, opacity: 0, type: 'from', delay: 200 }}
        >
          联系我们
        </TweenOne>
      </div>
    </div>
  );
};

export default Banner;
